module.exports = __webpack_public_path__ + "img/img-6.1dcc828b.png";